import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav>
      <ul className="flex flex-col md:flex-row items-center gap-4 md:gap-6 text-sm">
        <li>
          <Link to="/" className="hover:text-indigo-600 font-semibold">
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/job-vacancy"
            className="hover:text-indigo-600 font-semibold">
            Job
          </Link>
        </li>
        <li>
          <Link to="/about" className="hover:text-indigo-600 font-semibold">
            About
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
